import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "./content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Services = () => {
  const c = useContent();
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios.get(`${API}/services`).then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <Reveal>
            <span className="uppercase tracking-[0.24em] text-xs font-bold text-accent">{c.services_eyebrow}</span>
            <h2 className="mt-4 font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-xl leading-[1.02]">
              {c.services_title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-foreground/65 md:text-right">
              {c.services_subtitle}
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <motion.div
                data-testid={`service-card-${s.id}`}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="group h-full bg-card border border-border rounded-3xl overflow-hidden hover:shadow-[0_30px_60px_-30px_rgba(18,119,110,0.35)] transition-shadow duration-500"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent" />
                  <span className="absolute top-5 left-5 font-heading text-sm font-bold text-white/90 tracking-widest">
                    {s.no}
                  </span>
                  <span className="absolute top-4 right-4 grid place-items-center h-10 w-10 rounded-full bg-white/85 text-primary opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-[opacity,transform] duration-400">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
                <div className="p-7 md:p-8">
                  <h3 className="font-heading text-2xl font-medium tracking-tight text-foreground">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-foreground/65 leading-relaxed">{s.desc}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="text-xs font-medium px-3 py-1 rounded-full bg-secondary/15 text-primary"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
